import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function VimeoIcon({
	width,
	height,
	active = false,
	'aria-label': ariaLabel = 'Vimeo',
	style,
	customIconColor,
	...rest
}: IconRenderProps): ReactElement {
	const bg = customIconColor?.bgColor ?? '#FFFFFF';
	const g = customIconColor?.glyphColor ?? (active ? '#1E1E1E' : 'rgba(30,30,30,.48)');

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width ?? '100%'}
			height={height ?? '100%'}
			viewBox="0 0 40 40"
			fill="none"
			role="img"
			aria-label={ariaLabel}
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<title>Vimeo</title>

			<rect width="40" height="40" rx="8" fill={bg} />

			<g transform="translate(-3.7 -3.7) scale(0.095)">
				<path
					d="M350.1 133.3c-53 0-78.1 68.5-78.1 68.5l4.1 6c4.7-2.8 10.3-6 16.9-6 7.1 0 12.9 5.2 12.9 19 0 22.8-26.1 79-49.5 79-10.4 0-15.1-16.9-21.8-47.4-2.3-8.9-6.3-31.8-12.1-68.6-5.4-34.1-9.3-47.7-28.5-47.7-44.1 0-87.4 61.4-87.4 61.4l6.3 13.1c4.7-2.8 10.3-6 18.5-6 15.6 0 17.2 17.4 26.2 49.5 8.1 29.5 16 58.5 24.2 88.6 8.2 30 25.2 48.4 46 48.4 31.2 0 61.3-26.5 102.2-79.4 19-24.4 39-57.1 49.5-80.1 10.6-23.2 12.4-43 12.4-52.1-.2-26.4-10.6-46.2-41.8-46.2"
					fill={g}
				/>
			</g>
		</svg>
	);
}
